export class OrganizationCommandRequest {
    command: string = '';
}